const firebaseConfig = {
    apiKey: "AIzaSyAz8AF6omxtPpGnN9s9fqUWYNP6o_mek00",
    authDomain: "creative-agency-demo-client.firebaseapp.com",
    databaseURL: "https://creative-agency-demo-client.firebaseio.com",
    projectId: "creative-agency-demo-client",
    storageBucket: "creative-agency-demo-client.appspot.com",
    messagingSenderId: "1035404610279",
    appId: "1:1035404610279:web:2a203c11527c826bb6b042"
  };
  export default firebaseConfig;